/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import Checkbox from './components/Checkbox';
import pattern from '../../assets/images/pattern.png';
import services from '../../services/services';
import utils from '../../utils/utils';
import { AppContext } from '../../context/appContext';
import AddressData from './components/AddressData';
import InputWrapper from './components/InputWrapper';
import LocationSettingsAlert from './components/LocationSettingsAlert';
import { PriceContext } from '../../context/priceContext';
import PaymentLogos from './components/PaymentLogos';

import { CompanyContext } from '../../context/companyContext';

const OrderForm = ({
  orderData,
  addOrderDate,
  addOrderData,
  addressData,
  addAddressData,
  resetAddress,
  sendOrder,
  setDelivery,
  delivery,
  errors,
  setErrors,
  termsChecked,
  handleAcceptTerms,
  readAcceptTerms,
  paymentType,
  setPaymentType,
  formRef,
  isSimple,
  handleAcceptSimple,
  readSimpleTerms,
  simpleTermsChecked,
  needsInvoice,
  setNeedsInvoice,
  handleNeedsInvoice,
  toCompany,
  handleCompany,
  invName,
  setInvName,
  tax,
  setTax,
  invAddressData,
  addInvAddress,
  setInvAddress
}) => {
  const [locations, setLocations] = useState([]);
  const [payMethods, setPayMethods] = useState();
  const [times, setTimes] = useState();
  const [dates, setDates] = useState([]);
  const [hasSimplePay, setHasSimplePay] = useState(false);
  const [hasToday, setHasToday] = useState(false);
  const [maxHour, setMaxHour] = useState(23);
  // 2020-08-14 pjung ERINT-826 SimplePay logó kell-e
  const [logo, setLogo] = useState(false);
  const [disableInvoice, setDisableInvoice] = useState(false);

  const [settings] = useContext(AppContext);
  const [priceData, setPriceData] = useContext(PriceContext);
  const [company] = useContext(CompanyContext);

  const getSimpleStatus = async () => {
    const response = await services.getSimpleStatus();

    if (response.data?.status === 'OK') {
      // 2020-10-12 pjung ERINT-886 ACTIVE helyett TRUE
      setHasSimplePay(response.data.data?.value?.toLowerCase() === 'true');
    }
  };

  const getLocationList = async () => {
    const response = await services.getLocationList();

    if (response.data.status === 'OK') {
      setLocations(response.data.list);
    }
  };

  const getDates = async id => {
    const response = await services.getDates(id);

    if (response.data.status === 'OK') {
      const { nextOrder, daysInAdvance, daysOff, orderUntil, todayOrderUntil } = response.data.list[0];
      console.debug(
        `nextOrder=${nextOrder}, daysInAdvance=${daysInAdvance}, daysOff=${daysOff}, orderUntil=${orderUntil}, todayOrderUntil=${todayOrderUntil}`
      );
      setDates(utils.getDaysToChooseFrom(daysInAdvance, daysOff, orderUntil, todayOrderUntil, nextOrder));
      if (nextOrder === 0 && !utils.isTodayDisabled(daysOff)) {
        setHasToday(true);
        setMaxHour(todayOrderUntil);
      }
    }
  };

  const getPayMethods = async id => {
    const response = await services.getPayMethods(id);

    if (response.data.status === 'OK') {
      setPayMethods(response.data.list);
      console.log(response.data.list);
      // 2020-08-14 pjung ERINT-826 Logók megjelenítése csak azon helyszínen, ahol LEHETSÉGES a SimplePay fizetés...
      setLogo(response.data.list.some(pm => pm.type === 3));
    }
  };

  const getTimes = async id => {
    const response = await services.getTimes(id);

    if (response.data.status === 'OK') {
      setTimes(response.data.list);
    }
  };

  const getAllDataForLocation = () => {
    const id = orderData.location ? orderData.location : locations[0]?.id;

    id && getDates(id);
    id && getPayMethods(id);
    id && getTimes(id);
  };

  useEffect(() => {
    getLocationList();
    getSimpleStatus();
  }, []);

  useEffect(() => {
    getAllDataForLocation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locations, orderData.location]);

  useEffect(() => {
    setDelivery(false);
    // eslint-disable-next-line eqeqeq
    const current = locations.filter(loc => loc.id == orderData.location);
    const isDelivery = Number(current[0]?.type) === 1;
    return isDelivery ? setDelivery(true) : resetAddress();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData.location]);

  const handleSubmit = event => {
    event.preventDefault();
    sendOrder(canOrderToday());
  };

  const handleLocationChange = event => {
    const { value } = event.target;

    const selectedLocation = locations.filter(location => Number(location.id) === Number(value) && location)[0];

    setPriceData({
      ...priceData,
      deliveryFee: selectedLocation?.deliveryFee || 0,
      minOrder: selectedLocation?.minOrder || 0,
      freeDeliveryLimit: selectedLocation?.freeDeliveryLimit || 0
    });

    addOrderData(event);
  };

  // TODO
  // kivenni a fix 3-as erteket
  const handlePayMethodChange = event => {
    const { value } = event.target;

    const current = payMethods.find(el => Number(el.id) === Number(value));

    setPaymentType(current.type || 3);
    setDisableInvoice(current.autoInvoice);
    if (current.autoInvoice) {
      setNeedsInvoice(true);
    }
    addOrderData(event);
  };

  // 2020-07-08 pjung ERINT-774 Számlázási adatok bevitele

  const copyData = () => {
    // A név kell mindig?
    setInvName(orderData.name);
    // Kiszállítás esetén másolunk címet is...
    if (delivery) {
      setInvAddress(addressData);
    }
  };

  // 2020-07-16 pjung ERINT-774 Számlázási adatok bevitele

  const handleTax = event => {
    setTax(event.target.value);
  };

  const handleInvName = event => {
    setInvName(event.target.value);
  };

  // 2020-08-14 pjung ERINT-816 Adószám validálás

  const validateTax = async event => {
    const response = await check2Tax();

    if (response?.tax) {
      // Ha nincs hiba, a TAX értékét akkor is felül kell írni...
      setErrors({ ...errors, ...response, tax: response?.tax });
      return false;
    }
    return true;
  };

  // Hogy a services.checkTax() metódussal össze ne akadjon...
  const check2Tax = async () => {
    const response = {};
    // Cég esetén adószám
    console.log('toCompany = ', toCompany);
    if (toCompany) {
      // Ki van-e töltve?
      if (tax === '' || tax === null) {
        response.tax = 'Adjon meg adószámot';
        return response;
      }
      const parman = await services.getSetting('parman');
      if (parman?.data) {
        // 2020-08-24 pjung ERINT-836 Online ellenőrzés: NAV/parMAN...
        const check = await services.checkTax(tax);
        // console.log(check?.data);
        if (check?.data?.status !== 'OK') {
          console.log(check?.data?.status);
          response.tax = 'Adószám ellenőrzése sikertelen volt. Győződjön meg az adószám helyességéről, mielőtt leadja a rendelését';
        } else if (check?.data?.data?.startsWith('NAVOnline.Error')) {
          console.log(check.data.data);
          response.tax = 'Érvényes adószámot adjon meg';
        }
      }
      // DONE Offline ellenőrzés
      const check = utils.checkTax(tax);
      if (check) {
        console.log(check);
        response.tax = 'Érvényes adószámot adjon meg';
      }
    }
    return response;
  };

  const isToday = () => {
    return hasToday && dates.filter(date => date.slice(0, 10) === orderData.date)[0] === utils.todayData();
  };

  const canOrderToday = () => {
    return !isToday() || new Date().getHours() <= maxHour;
  };

  const generateHtml = () => ({ __html: company.todayNotice });

  return (
    <Root
      bgcolor={settings?.productListBackground || `#ffe0a2`}
      pattern={settings?.deliveryPattern ? `/upload/${settings.deliveryPattern}` : pattern}
    >
      <Form bgcolor={settings?.orderBackground || `#ffeab4`} onSubmit={handleSubmit}>
        <Divider />
        <FlexItem width="30%">
          <Title>Átvételi adatok</Title>
        </FlexItem>
        <FlexItem width="70%">
          <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="location">Helyszín</label>
            <select required id="location" name="location" type="select" onChange={handleLocationChange} value={orderData.location}>
              <option value="" defaultValue>
                Kérjük válassz
              </option>
              {locations.map(location => (
                <option key={location.id} value={location.id}>
                  {location.description}
                </option>
              ))}
            </select>
          </InputWrapper>
          <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <LocationSettingsAlert />
          </InputWrapper>
          <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="date"> Dátum</label>
            <select
              required
              id="date"
              name="date"
              type="select"
              placeholder="Melyik napon jönnél?"
              onChange={addOrderDate}
              value={dates.filter(date => date.slice(0, 10) === orderData.date)[0] || ''}
            >
              <option value="" defaultValue>
                Kérjük válassz
              </option>
              {dates &&
                dates.map(date => (
                  <option key={date} value={date}>
                    {date}
                  </option>
                ))}
            </select>
          </InputWrapper>
          {isToday() ? (
            <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
              <div className="content" dangerouslySetInnerHTML={company?.todayNotice && generateHtml()} />
            </InputWrapper>
          ) : (
            <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
              <label htmlFor="time">Időpont</label>
              <select required id="time" name="time" type="select" onChange={addOrderData} value={orderData.time}>
                <option value="" defaultValue>
                  Kérjük válassz
                </option>
                {times && times.map(time => <option key={time.id} value={time.id}>{`${time.from}-${time.to} óra között`}</option>)}
              </select>
            </InputWrapper>
          )}

          <InputWrapper bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="payMethod">Fizetési mód </label>
            <select
              required
              id="payMethod"
              name="payMethod"
              type="select"
              placeholder="Mivel fizetnél?"
              onChange={handlePayMethodChange}
              value={orderData.payMethod}
            >
              <option value="" defaultValue>
                Kérjük válassz
              </option>
              {payMethods &&
                payMethods.map(method => (
                  <option key={method.id} value={method.id}>
                    {method.description}
                  </option>
                ))}
            </select>
          </InputWrapper>
          <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            {hasSimplePay && logo && <PaymentLogos />}
          </InputWrapper>
          {delivery && <AddressData delivery={delivery} addAddressData={addAddressData} addressData={addressData} />}
          <InputWrapper className="descriptionBox" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="description">Megjegyzés</label>
            <textarea
              name="description"
              id="description"
              rows="5"
              onChange={addOrderData}
              value={orderData.description}
              placeholder="Megjegyzés a rendeléshez"
            />
          </InputWrapper>
        </FlexItem>

        <Divider />

        <FlexItem width="30%">
          <Title>Fizetendő összesen</Title>
        </FlexItem>
        <FlexItem width="70%" col>
          <Title className="totalPrice">{priceData.total > 0 && `${utils.priceMask(priceData.total)} Ft`}</Title>
        </FlexItem>

        <Divider />

        <FlexItem width="30%">
          <Title>Személyes adatok</Title>
        </FlexItem>
        <FlexItem width="70%">
          <InputWrapper className="descriptionBox" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="name">Név</label>
            <input required name="name" id="name" onChange={addOrderData} value={orderData.name} placeholder="Teljes neved" />
          </InputWrapper>
          <InputWrapper className="descriptionBox" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="date">Email</label>
            <input
              required
              name="email"
              id="email"
              onChange={addOrderData}
              value={orderData.email}
              placeholder="Ide kapsz visszaigazolást a rendelésről"
            />
          </InputWrapper>
          <InputWrapper className="descriptionBox" bgcolor={settings?.orderInputBg || `#e7c37a`}>
            <label htmlFor="time">Telefonszám</label>
            <input
              required={delivery}
              name="phone"
              id="phone"
              onChange={addOrderData}
              value={orderData.phone}
              placeholder="Csak akkor hívunk ha fontos."
            />
          </InputWrapper>
        </FlexItem>

        {/* 2020-07-07 pjung ERINT-774 Számlázási cím bekérése */}

        <Divider style={{ margin: '2em 0' }} />

        <FlexItem width="30%">
          <Title>Számlázási adatok</Title>
        </FlexItem>
        <FlexItem width="70%">
          <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`} style={{ minWidth: '40%' }}>
            <CheckboxWrapper style={{ display: 'flex', justifyContent: 'space-around' }}>
              <Checkbox
                value={needsInvoice}
                onChange={() => {
                  if (!disableInvoice) handleNeedsInvoice();
                }}
                color={settings?.orderInputBg || `#e7c37a`}
                text="Számlát kérek"
              />
            </CheckboxWrapper>
          </InputWrapper>

          {/* 2020-07-07 pjung ERINT-774 FIXME adatok átvétele a rendelésből, ha lehet */}
          <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`} style={{ minWidth: '40%' }}>
            {needsInvoice && (
              <CheckboxWrapper style={{ display: 'flex', justifyContent: 'space-around' }}>
                <Checkbox value={toCompany} onChange={handleCompany} color={settings?.orderInputBg || `#e7c37a`} text="Cégre kérem" />
              </CheckboxWrapper>
            )}
          </InputWrapper>
          {needsInvoice && (
            <>
              <InputWrapper width="100%" bgcolor={settings?.orderInputBg || `#e7c37a`}>
                <Button
                  bgcolor={settings?.buttonBackground || `#e80000`}
                  style={{ fontFamily: settings.fontFamily }}
                  type="button"
                  onClick={copyData}
                >
                  Adatok a rendelésből
                </Button>
              </InputWrapper>

              <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`}>
                <label htmlFor="date">Számlázási név</label>
                <input required name="invName" id="invName" onChange={handleInvName} value={invName} />
              </InputWrapper>

              <InputWrapper width="40%" bgcolor={settings?.orderInputBg || `#e7c37a`} style={{ minWidth: '40%' }}>
                {toCompany && (
                  <>
                    <label htmlFor="tax">Adószám</label>
                    <InputMask
                      required
                      mask="99999999-9-99"
                      maskChar={null}
                      name="tax"
                      id="tax"
                      value={tax}
                      onChange={handleTax}
                      onBlur={validateTax}
                    />
                  </>
                )}
              </InputWrapper>

              <AddressData delivery={needsInvoice} addAddressData={addInvAddress} addressData={invAddressData} />
            </>
          )}
        </FlexItem>

        <Divider style={{ margin: '2em 0' }} />

        <FlexItem width="100%" col>
          <CheckboxWrapper style={{ display: 'flex' }}>
            <Checkbox value={termsChecked} onChange={handleAcceptTerms} color={settings?.orderInputBg || `#e7c37a`} />
            <span role="button" className="linkText" onClick={readAcceptTerms}>
              A felhasználási feltételeket elolvastam és megértettem
            </span>
          </CheckboxWrapper>
          {isSimple() && (
            // 2025-12-02 pjung ERINT-13 OTP kivétele a szövegből
            <CheckboxWrapper style={{ display: 'flex' }}>
              <Checkbox value={simpleTermsChecked} onChange={handleAcceptSimple} color={settings?.orderInputBg || `#e7c37a`} />
              <span role="button" className="linkText" onClick={readSimpleTerms}>
                A SimplePay Adattovábbítási nyilatkozatot megértettem és elfogadom.
              </span>
            </CheckboxWrapper>
          )}
          <Button bgcolor={settings?.buttonBackground || `#e80000`} style={{ fontFamily: settings.fontFamily }} type="submit" ref={formRef}>
            Megrendelem
          </Button>
          {Object.values(errors)[0] && <ErrorText>{Object.values(errors)[0]}</ErrorText>}

          <Divider />
        </FlexItem>
      </Form>
    </Root>
  );
};

export default OrderForm;

OrderForm.propTypes = {
  orderData: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    location: PropTypes.string,
    payMethod: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  addressData: PropTypes.shape({
    zip: PropTypes.string,
    city: PropTypes.string,
    street: PropTypes.string,
    streetType: PropTypes.string,
    house: PropTypes.string
  }).isRequired,
  addOrderData: PropTypes.func.isRequired,
  addOrderDate: PropTypes.func.isRequired,
  addAddressData: PropTypes.func.isRequired,
  resetAddress: PropTypes.func.isRequired,
  sendOrder: PropTypes.func.isRequired,
  delivery: PropTypes.bool.isRequired,
  setDelivery: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    productList: PropTypes.string
  }).isRequired,
  termsChecked: PropTypes.bool.isRequired,
  handleAcceptTerms: PropTypes.func.isRequired,
  readAcceptTerms: PropTypes.func.isRequired,
  setPaymentType: PropTypes.func.isRequired,
  formRef: PropTypes.node.isRequired,
  isSimple: PropTypes.func.isRequired,
  handleAcceptSimple: PropTypes.func.isRequired,
  readSimpleTerms: PropTypes.func.isRequired,
  simpleTermsChecked: PropTypes.bool.isRequired,
  // 2020-07-07 pjung ERINT-774
  needsInvoice: PropTypes.bool.isRequired,
  handleNeedsInvoice: PropTypes.func.isRequired,
  toCompany: PropTypes.bool.isRequired,
  handleCompany: PropTypes.func.isRequired,
  invName: PropTypes.string.isRequired,
  setInvName: PropTypes.bool.isRequired,
  tax: PropTypes.string.isRequired,
  setTax: PropTypes.func.isRequired,
  invAddressData: PropTypes.shape({
    zip: PropTypes.string,
    city: PropTypes.string,
    street: PropTypes.string,
    streetType: PropTypes.string,
    house: PropTypes.string
  }).isRequired,
  addInvAddress: PropTypes.func.isRequired,
  setInvAddress: PropTypes.func.isRequired
};

const Root = styled.div`
  background-image: ${props => `url(${props.pattern})`};
  padding: 60px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  background-color: ${props => props.bgcolor};
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 1000px) {
    padding: 25px;
    padding-top: 60px;
  }

  @media (max-width: 600px) {
    padding: 12px;
    padding-top: 60px;
  }
`;

const Form = styled.form`
  background-color: ${props => props.bgcolor};
  max-width: 1300px;
  width: 100%;
  box-shadow: 1px 5px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 50px 50px 50px 50px;
  padding: 1em 3em;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 1000px) {
    flex-direction: column;
  }

  @media (max-width: 700px) {
    padding: 1em;
  }
`;

const FlexItem = styled.div`
  width: ${props => (props.width ? props.width : '')};
  display: flex;
  flex-direction: ${props => (props.col ? 'column' : 'row')};
  justify-content: ${props => (props.col ? 'flex-end' : 'space-around')};
  align-content: ${props => (props.col ? 'flex-end' : '')};
  flex-wrap: wrap;

  @media (max-width: 1100px) {
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    width: 100%;
  }
`;

const Title = styled.h3`
  text-transform: uppercase;
  font-size: 2em;
  margin: 0;

  &.totalPrice {
    margin-right: 5%;
  }

  @media (max-width: 1000px) {
    margin-bottom: 1em;
    font-size: 1.8em;

    &.totalPrice {
      margin-right: 0;
    }
  }
`;

const Divider = styled.div`
  width: 100%;
  height: 2px;
  border-bottom: 1px dashed gray;
  margin: 5em 0;
`;

const Button = styled.button`
  background-color: ${props => props.bgcolor};
  border: none;
  color: white;
  height: 40px;
  border-radius: 60px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: 1em;
  font-family: 'inherit';
  width: 70%;
  margin-left: 15%;

  &:hover {
    filter: brightness(90%);
  }

  &:focus {
    outline: none;
  }
`;

const ErrorText = styled.p`
  color: red;
`;

const CheckboxWrapper = styled.div`
  display: flex;

  & .linkText {
    text-decoration: underline;
    cursor: pointer;
  }
`;
